exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".SortSwitcher{margin:0 0 0 32px}.SortSwitcher img{transition:transform 250ms ease-out}.SortSwitcher img.rotate{transform:rotate(180deg)}.SortSwitcher img.disabled{filter:grayscale(1)}", ""]);
